import { Block } from '@openlaw-au/types';
import { FunctionComponent } from 'react';
import BlockRenderer from './blockRenderer';
interface Props {
  block: Block;
  list_num?: string;
}

const OrderedListRenderer: FunctionComponent<Props> = ({ block }) => {
  return (
    <div className="flex flex-col content-center">
      {block.blocks.map((listItem, key) => {
        const [valueMeta, splitMeta] = listItem.meta;
        return (
          <div className="flex flex-row content-center space-x-3" key={key}>
            <div className={'items-center min-w-[20px] mt-2'}>
              {valueMeta?.type === 'label' && (!splitMeta || splitMeta?.value !== 'true') && (
                <p>{valueMeta?.value ?? ''}</p>
              )}
            </div>
            <div className="flex flex-col">
              <div>
                {listItem.blocks.map((b, k) => {
                  return (
                    <div key={k}>
                      <BlockRenderer block={b} />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default OrderedListRenderer;
